import React from "react";
import { ShieldCheck, Star, BadgeCheck, BellRing, BadgeEuro } from "lucide-react";
import { companyInfo } from "../data/mock";

const items = [
  { icon: ShieldCheck, title: "Volledig verzekerd", text: "Bedrijfsaansprakelijkheid & schade gedekt" },
  { icon: Star, title: `${companyInfo.rating} uit ${companyInfo.reviewCount} reviews`, text: "Geverifieerde Google-beoordelingen" },
  { icon: BellRing, title: "24 uur vooraf bericht", text: "Nooit meer onverwacht op de stoep" },
  { icon: BadgeEuro, title: "Prijs vooraf", text: "Geen voorrijkosten, geen verrassingen" },
  { icon: BadgeCheck, title: `KvK ${companyInfo.kvk}`, text: "Erkend bedrijf uit Rosmalen" },
];

const TrustStrip = () => (
  <section className="bg-white pb-4 pt-2" aria-label="Waarom Cleven Cleaning" data-testid="trust-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <ul className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 bg-slate-50 border border-slate-100 rounded-2xl p-4 sm:p-5">
        {items.map(({ icon: Icon, title, text }) => (
          <li key={title} className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-teal-500 flex items-center justify-center flex-shrink-0 shadow-md shadow-sky-500/20">
              <Icon className="w-5 h-5 text-white" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-slate-800 text-sm leading-tight">{title}</p>
              <p className="text-xs text-slate-500 mt-0.5">{text}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustStrip;
